import { Config } from "./types";

const config: Config = {
    //dashboardUrl: "https://dashboard-staging.fitforwork.ai",
    dashboardSubdomain: "dashboard-staging",
};

export default config;
